import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { hasConsent, subscribeConsent } from "@/lib/cookieConsent";

const POSTHOG_KEY = "phc_pF3RBMnjfY7NJLXJwt4d9HTmsGopTeBMqGUa3KwCVSBZ";
const POSTHOG_HOST = "https://eu.i.posthog.com";

let initialized = false;

function initPostHog() {
  if (initialized || typeof window === "undefined" || !hasConsent("analytics")) return;
  if (!POSTHOG_KEY) return;
  initialized = true;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // handled manually on SPA route change
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true, // error capture
    persistence: "localStorage+cookie",
    opt_out_capturing_by_default: true,
    // Ensure feature flags (A/B variants) are fetched at startup and on identify.
    bootstrap: {},
    advanced_disable_feature_flags: false,
  });
  posthog.opt_in_capturing({ captureEventName: false });
}

const PostHogTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const sync = () => {
      if (!hasConsent("analytics")) {
        if (initialized) {
          posthog.set_config({ autocapture: false, capture_pageleave: false, capture_exceptions: false, advanced_disable_feature_flags: true });
          posthog.opt_out_capturing();
        }
        return;
      }
      initPostHog();
      if (!initialized) return;
      posthog.set_config({ autocapture: true, capture_pageleave: true, capture_exceptions: true, advanced_disable_feature_flags: false });
      posthog.opt_in_capturing({ captureEventName: false });
      posthog.capture("$pageview", { $current_url: window.location.href, path: location.pathname + location.search, title: document.title });
    };
    sync();
    return subscribeConsent(sync);
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogTracker;
